import React from 'react';
import styled from 'styled-components';
import { Window } from '../Window/Window';

const AboutContainer = styled.div`
  padding: 20px;
  background: #c3c3c3;
  font-family: 'VT323', monospace;
  height: calc(100% - 25px);
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 16px;
  }
  
  &::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-left: 1px solid #808080;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #808080;
    border: 1px solid #c0c0c0;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }
`;

const Title = styled.h1`
  color: #000080;
  margin-bottom: 20px;
  text-align: center;
`;

const Section = styled.div`
  margin-bottom: 20px;
  line-height: 1.5;
`;

const Link = styled.a`
  color: #000080;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #0000ff;
  }
`;

export const About = ({ 
  onClose, 
  isActive, 
  onActivate, 
  isMinimized, 
  isMaximized, 
  onMinimize, 
  onMaximize,
  initialPosition
}) => {
  return (
    <Window
      title="About"
      onClose={onClose}
      isActive={isActive}
      onActivate={onActivate}
      isMinimized={isMinimized}
      isMaximized={isMaximized}
      onMinimize={onMinimize}
      onMaximize={onMaximize}
      initialPosition={initialPosition}
      defaultWidth="600px"
      defaultHeight="400px"
    >
      <AboutContainer>
        <Title> hey, I'm David!</Title>
        
        <Section>
          i'm currently doing marketing, product, and more at{' '}
          <Link href="https://etherlink.com" target="_blank">Etherlink</Link>
          , an EVM compatible Layer 2 built on Tezos.
        </Section>

        <Section>
          when I'm not working to improve the Etherlink ecosystem, you can find me:
          <ul>
          <br />
          <li>exploring DeFi </li>
            <li>playing Counter-Strike</li>
            <li>climbing stuff</li>
            <li>doing crypto things </li>
            <li>vibe coding fun projects</li>
            <li>& building random things</li>
          </ul>
        </Section>

        <Section>
        <b> about this project:</b>
          <br /><br />
          DavidOS was inspired by{' '}
          <Link href="https://henryheffernan.com" target="_blank">Henry Heffernan</Link>
          's awesome work. 
          <br /><br />
          i created this for fun and to showcase what
          I'm working on who I am and in a fun way. feel free to explore around -
          there might be some easter eggs hidden in here! 
          <br /><br />
       
          <b>find more info about this project in the projects folder</b>
          <br /><br />
          <b>find me on X {' '}
          <Link href="https://x.com/0xDavidR" target="_blank">@0xDavidR</Link></b>
        </Section>

        <Section style={{ fontSize: '12px', textAlign: 'center', color: '#666' }}>
          DavidOS v1.69 - way too much time was spent on this 
        </Section>
      </AboutContainer>
    </Window>
  );
}; 